import { AUTH } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

const INITIAL_STATE = {
  accessToken: localStorage.getItem('accessToken', ''),
  refreshToken: localStorage.getItem('refreshToken', ''),
  loginStatus: undefined,
  loginError: undefined,
  challengeName: undefined,
  session: undefined,
  username: undefined,
  passwordChallengeResponseStatus: undefined,
  passwordChallengeResponseError: undefined,
  forgotPasswordStatus: undefined,
  forgotPasswordError: undefined,
  changePasswordStatus: undefined,
  changePasswordError: undefined,
  passwordReset: undefined,
  resendInvitationStatus: null,
  resendInvitationError: null,
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AUTH.UNSET:
      return {
        ...state,
        [action.payload]: undefined,
      };
    case AUTH.RESEND_INVITATION:
      return {
        ...state,
        resendInvitationStatus: CONSTANTS.API.STARTED,
      };
    case AUTH.RESEND_INVITATION_SUCCEEDED:
      return {
        ...state,
        resendInvitationStatus: CONSTANTS.API.SUCCEEDED,
      };
    case AUTH.RESEND_INVITATION_FAILED:
      return {
        ...state,
        resendInvitationStatus: CONSTANTS.API.FAILED,
        resendInvitationError: action.payload,
      };
    case AUTH.PASSWORD_RESET:
      return {
        ...state,
        username: action.payload,
        passwordReset: true,
      };
    case AUTH.LOGIN:
      return {
        ...state,
        username: action.payload.username,
        loginStatus: CONSTANTS.API.STARTED,
      };
    case AUTH.LOGIN_SUCCEEDED:
      return {
        ...state,
        loginStatus: CONSTANTS.API.SUCCEEDED,
      };
    case AUTH.LOGIN_FAILED:
      return {
        ...state,
        loginStatus: CONSTANTS.API.FAILED,
        loginError: action.payload,
      };
    case AUTH.PASSWORD_CHALLENGE:
      return {
        ...state,
        challengeName: action.payload.challengeName,
        session: action.payload.session,
        username: action.payload.username,
      };
    case AUTH.PASSWORD_CHALLENGE_RESPONSE:
      return {
        ...state,
        passwordChallengeResponseStatus: CONSTANTS.API.STARTED,
      };
    case AUTH.PASSWORD_CHALLENGE_RESPONSE_SUCCEEDED:
      return {
        ...state,
        passwordChallengeResponseStatus: CONSTANTS.API.SUCCEEDED,
        loginStatus: CONSTANTS.API.SUCEEDED,
      };
    case AUTH.PASSWORD_CHALLENGE_RESPONSE_FAILED:
      return {
        ...state,
        passwordChallengeResponseStatus: CONSTANTS.API.FAILED,
        passwordChallengeResponseError: action.payload,
      };
    case AUTH.FORGOT_PASSWORD:
      return {
        ...state,
        forgotPasswordStatus: CONSTANTS.API.STARTED,
        username: action.payload,
      };
    case AUTH.FORGOT_PASSWORD_SUCCEEDED:
      return {
        ...state,
        forgotPasswordStatus: CONSTANTS.API.SUCCEEDED,
      };
    case AUTH.FORGOT_PASSWORD_FAILED:
      return {
        ...state,
        forgotPasswordStatus: CONSTANTS.API.FAILED,
        forgotPasswordError: action.payload,
      };
    case AUTH.CHANGE_PASSWORD:
      return {
        ...state,
        changePasswordStatus: CONSTANTS.API.STARTED,
      };
    case AUTH.CHANGE_PASSWORD_SUCCEEDED:
      return {
        ...state,
        changePasswordStatus: CONSTANTS.API.SUCCEEDED,
      };
    case AUTH.CHANGE_PASSWORD_FAILED:
      return {
        ...state,
        changePasswordStatus: CONSTANTS.API.FAILED,
        changePasswordError: action.payload,
      };
    case AUTH.LOGOUT:
      return {
        ...state,
        logoutStatus: CONSTANTS.API.STARTED,
      };
    case AUTH.LOGOUT_SUCCEEDED:
      return {
        ...state,
        logoutStatus: CONSTANTS.API.SUCCEEDED,
      };
    case AUTH.LOGOUT_FAILED:
      return {
        ...state,
        logoutStatus: CONSTANTS.API.FAILED,
      };
    default:
      return state;
  }
};
